import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { keyframes, css } from '@mui/system';
import { cssTransition, ToastContainer as ToastContainer$1 } from 'react-toastify';

const DURATION_IN_MS = 3000;
const TOAST_NUMBER = 3;
const ToastContainer = (props) => (jsx(StyledToastContainer, Object.assign({ autoClose: DURATION_IN_MS, closeButton: false, closeOnClick: false, draggable: false, limit: TOAST_NUMBER, position: "bottom-right", transition: Animation, hideProgressBar: true }, props)));
const slideLeft = keyframes `
  0% {
    transform: translateX(110%);
  }
  100% {
    transform: translateX(0);
  }
`;
const slideRight = keyframes `
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(110%);
  }
}
`;
const Animation = cssTransition({
    enter: "enter-animation",
    exit: "exit-animation",
});
const StyledToastContainer = styled(ToastContainer$1)({
    "&&&.Toastify__toast-container": {
        width: "unset",
        padding: 0,
    },
    ".Toastify__toast": {
        padding: 0,
        minHeight: 0,
        borderRadius: 8,
        background: "transparent",
        overflow: "unset",
        boxShadow: "none",
    },
    ".Toastify__toast-body": {
        padding: 0,
    },
}, css `
    .exit-animation {
      animation: ${slideRight} 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
    }

    .enter-animation {
      animation: ${slideLeft} 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
  `);

export { ToastContainer };
//# sourceMappingURL=ToastContainer.js.map
